"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var react_apollo_1 = require("react-apollo");

var ApolloContext_1 = require("./ApolloContext");

function ApolloProvider(_a) {
  var client = _a.client,
      children = _a.children;
  return react_1.default.createElement(react_apollo_1.ApolloProvider, {
    client: client
  }, react_1.default.createElement(ApolloContext_1.ApolloContext.Provider, {
    value: {
      client: client,
      operations: client.__operations_cache__
    }
  }, children));
}

exports.ApolloProvider = ApolloProvider;